/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, useMemo } from 'react';
import UserService from "../../services/UserService";
import { If } from "../../utils/Controls";
import { AntdPaging, AntdTag } from "../../utils/Antd";
import util from "../../utils/util";
import Tabs, { PageHeading } from "./Tabs";
import edit from "../assets/icons/pen-to-square-solid.svg";
import xmark from "../assets/icons/circle-xmark-solid.svg";
import { Input, Button, message, Modal, Checkbox, Tag } from 'antd';
import { ExclamationCircleOutlined, CheckSquareOutlined, BorderOutlined } from '@ant-design/icons';
const { confirm } = Modal;

// ─── Group colour palette ─────────────────────────────────────────────────────
const GROUP_STYLES = {
    'Master':   { header: '#1a3a5c', light: '#e6f4ff', border: '#91caff', text: '#0958d9' },
    'Asset':    { header: '#389e0d', light: '#f6ffed', border: '#b7eb8f', text: '#237804' },
    'Job Card': { header: '#d46b08', light: '#fff7e6', border: '#ffd591', text: '#ad4e00' },
    'Fleet':    { header: '#722ed1', light: '#f9f0ff', border: '#d3adf7', text: '#531dab' },
};
const DEFAULT_STYLE = { header: '#595959', light: '#fafafa', border: '#d9d9d9', text: '#434343' };

const groupStyle = (name) => GROUP_STYLES[name] || DEFAULT_STYLE;

export default function Role() {
    const [result, setResult] = useState({ data: [], page: {} });
    const [modules, setModules] = useState([]);
    const sdataRef = useRef({ p: 1, ps: 25 });
    const formRef = useRef();

    const list = (p, ps) => {
        sdataRef.current.p  = p  || 1;
        sdataRef.current.ps = ps || sdataRef.current.ps;
        util.showLoader();
        UserService.roles(sdataRef.current).then(({ data }) => {
            setResult(data.result);
        }).catch(e => message.error(e.message))
          .finally(() => util.hideLoader());
    };

    const deleteRecord = (id) => {
        message.destroy();
        confirm({
            title: 'Do you Want to delete this role?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes', okType: 'danger', cancelText: 'No',
            onOk() {
                util.showLoader();
                UserService.deleteRole(id)
                    .then(({ data }) => { message.success(data.message || 'Deleted'); list(); })
                    .catch(e => message.error(e.message))
                    .finally(() => util.hideLoader());
            },
        });
    };

    useEffect(() => {
        list();
        UserService.modules().then(res => setModules([...res.data.data]));
        return () => message.destroy();
    }, []);

    return (
        <div className="page-content">
            <div className="page-head uc d-flex">
                <div className="my-auto"><PageHeading /></div>
                <div className="my-auto ml-auto" />
            </div>
            <div className="page-pad">
                <div className="tabbable-custom">
                    <Tabs active="roles" />
                    <div className="tab-content">
                        <div className="tab-pane fade1 show active">
                            {result.data.length > 0 && (
                                <div className="text-secondary mb8">
                                    Showing {result.page.start + 1} – {result.page.start + result.page.total} of {result.page.total_records} records.
                                </div>
                            )}
                            <div className="d-flex tbl-search-head">
                                <div className="my-auto">
                                    <SearchForm dataRef={sdataRef} onSearch={list} />
                                </div>
                                <div className="ml-auto my-auto">
                                    <Button type="primary" onClick={() => formRef.current.openForm()}>
                                        <i className="fa fa-plus mr5" /> Add User Role
                                    </Button>
                                </div>
                            </div>
                            <If cond={result.data.length}>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-md table-striped table-hover m-0">
                                        <thead className="thead-light text-uppercase table-text-vmid">
                                            <tr>
                                                <th className="w20">SN</th>
                                                <th>Role Name</th>
                                                <th>Module Groups Assigned</th>
                                                <th className="w60">Status</th>
                                                <th className="w70" />
                                            </tr>
                                        </thead>
                                        <tbody className="table-text-top">
                                            {result.data.map((v, i) => {
                                                // Build group summary from app_modules
                                                const assignedIds = (v.app_modules || []).map(Number);
                                                const groupsUsed  = [...new Set(
                                                    modules
                                                        .filter(m => assignedIds.includes(Number(m.id)))
                                                        .map(m => m.group_name)
                                                        .filter(Boolean)
                                                )];
                                                return (
                                                    <tr key={i}>
                                                        <td>{result.page.start + i + 1}.</td>
                                                        <td style={{ fontWeight: 500 }}>{v.title}</td>
                                                        <td>
                                                            <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
                                                                {groupsUsed.length > 0
                                                                    ? groupsUsed.map(g => {
                                                                        const s = groupStyle(g);
                                                                        return (
                                                                            <span key={g} style={{
                                                                                fontSize: 11, fontWeight: 500,
                                                                                padding: '2px 8px', borderRadius: 10,
                                                                                background: s.light,
                                                                                border: `1px solid ${s.border}`,
                                                                                color: s.text,
                                                                            }}>{g}</span>
                                                                        );
                                                                    })
                                                                    : <span style={{ color: '#aaa', fontSize: 12 }}>No modules assigned</span>
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="nowrap">
                                                            {v.status
                                                                ? <AntdTag type="success">Active</AntdTag>
                                                                : <AntdTag type="danger">Inactive</AntdTag>}
                                                        </td>
                                                        <td className="text-center">
                                                            <Button.Group size="small">
                                                                <Button type="default" disabled={v.id * 1 < 3}
                                                                    onClick={() => formRef.current.openForm(v)}>
                                                                    <img src={edit} alt="" className="mr5" height={15} />
                                                                </Button>
                                                                <Button type="default" disabled={v.id * 1 < 3}
                                                                    onClick={() => deleteRecord(v.id)}>
                                                                    <img src={xmark} alt="" className="mr5" height={15} />
                                                                </Button>
                                                            </Button.Group>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex tbl-foot-bx">
                                    <AntdPaging
                                        onChange={list}
                                        total={result.page.total_records}
                                        current={result.page.cur_page}
                                        pageSize={sdataRef.current.ps}
                                        showSizeChanger
                                    />
                                </div>
                            </If>
                            <If cond={!result.data.length}>
                                <div className="no-rec">No record found</div>
                            </If>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm ref={formRef} callback={list} pageno={sdataRef.current.p} modules={modules} />
        </div>
    );
}

// ─── Search Form ──────────────────────────────────────────────────────────────
const SearchForm = ({ dataRef, onSearch }) => {
    const [data, setData] = useState({ ...dataRef.current });
    const handleChange = (v, k) => { data[k] = v; setData({ ...data }); };
    useEffect(() => { dataRef.current = { ...data }; }, [data]);
    useEffect(() => {
        setData({ ...data, p: dataRef.current.p, ps: dataRef.current.ps });
    }, [dataRef.current.p, dataRef.current.ps]);
    return (
        <form onSubmit={e => e.preventDefault()} autoComplete="off" spellCheck="false">
            <div className="d-flex">
                <div><Input placeholder="Search" allowClear value={data.k} onChange={e => handleChange(e.target.value, 'k')} /></div>
                <div><Button type="primary" icon={<i className="fa fa-search fs13" />} onClick={() => onSearch()} /></div>
            </div>
        </form>
    );
};

// ─── Add / Edit Form ──────────────────────────────────────────────────────────
const AddForm = forwardRef(({ callback, pageno, modules }, ref) => {
    const [showForm, setShowForm] = useState(false);
    const [data, setData]         = useState(null);
    const isNational              = util.isNational();

    // Group modules by group_name
    const groupedModules = useMemo(() => {
        const groups = {};
        modules.forEach(m => {
            const grp = m.group_name || 'Other';
            if (!groups[grp]) groups[grp] = { id: m.group_id, name: grp, items: [] };
            groups[grp].items.push(m);
        });
        // Sort groups: Master, Asset, Job Card, Fleet, others
        const ORDER = ['Master', 'Asset', 'Job Card', 'Fleet'];
        return Object.values(groups).sort((a, b) => {
            const ai = ORDER.indexOf(a.name), bi = ORDER.indexOf(b.name);
            if (ai === -1 && bi === -1) return a.name.localeCompare(b.name);
            if (ai === -1) return 1;
            if (bi === -1) return -1;
            return ai - bi;
        });
    }, [modules]);

    const handleChange = (v, k) => { data[k] = v; setData({ ...data }); };

    const toggleModule = (id, checked) => {
        const mods = [...(data.app_modules || [])];
        if (checked) { if (!mods.includes(id)) mods.push(id); }
        else { const idx = mods.indexOf(id); if (idx > -1) mods.splice(idx, 1); }
        setData({ ...data, app_modules: mods });
    };

    // Select all / deselect all within a group
    const toggleGroup = (groupItems, checked) => {
        const groupIds  = groupItems.map(m => m.id);
        let mods        = [...(data.app_modules || [])];
        if (checked) {
            mods = [...new Set([...mods, ...groupIds])];
        } else {
            mods = mods.filter(id => !groupIds.includes(id));
        }
        setData({ ...data, app_modules: mods });
    };

    // Check state of a group: all / some / none
    const groupCheckState = (groupItems) => {
        const groupIds  = groupItems.map(m => m.id);
        const selected  = groupIds.filter(id => (data?.app_modules || []).includes(id));
        if (selected.length === 0)            return 'none';
        if (selected.length === groupIds.length) return 'all';
        return 'some';
    };

    const save = () => {
        message.destroy();
        util.showLoader();
        UserService.saveRole(data)
            .then(({ data: res }) => {
                message.success(res.message || 'Saved');
                callback(data.id ? pageno : 1);
                setShowForm(false);
            })
            .catch(e => message.error(e.message))
            .finally(() => util.hideLoader());
    };

    const saveForAll = () => {
        message.destroy();
        util.showLoader();
        UserService.saveRoleForAllClients(data)
            .then(({ data: res }) => {
                message.success(res.message || 'Saved');
                callback(data.id ? pageno : 1);
                setShowForm(false);
            })
            .catch(e => message.error(e.message))
            .finally(() => util.hideLoader());
    };

    useImperativeHandle(ref, () => ({
        openForm(dtl) {
            setData(dtl ? { ...dtl } : { app_modules: [], status: '1' });
            setShowForm(true);
        },
    }));

    if (!data) return null;

    const assignedCount = (data.app_modules || []).length;

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span>{data.id ? 'Edit' : 'Add'} Role</span>
                    {assignedCount > 0 && (
                        <span style={{
                            fontSize: 11, fontWeight: 500, padding: '2px 8px',
                            borderRadius: 10, background: '#f6ffed',
                            border: '1px solid #b7eb8f', color: '#389e0d',
                        }}>
                            {assignedCount} module{assignedCount !== 1 ? 's' : ''} selected
                        </span>
                    )}
                </div>
            }
            visible={showForm}
            onCancel={() => setShowForm(false)}
            destroyOnClose
            maskClosable={false}
            width={1000}
            footer={[
                <Button key="cancel" onClick={() => setShowForm(false)}>Cancel</Button>,
                isNational && (
                    <Button key="saveAll" type="default" onClick={saveForAll}>
                        Save For All Facilities
                    </Button>
                ),
                <Button key="save" type="primary" onClick={save}>Save</Button>,
            ].filter(Boolean)}
        >
            <form onSubmit={e => { e.preventDefault(); save(); }} autoComplete="off" spellCheck="false">
                <div className="noselect">
                    {/* Role name */}
                    <div className="row mingap" style={{ marginBottom: 16 }}>
                        <div className="col-md-6 form-group">
                            <label className="req">Role Name</label>
                            <Input value={data.title || ''} onChange={e => handleChange(e.target.value, 'title')} />
                        </div>
                        <div className="col-md-3 form-group">
                            <label className="req">Status</label>
                            <select className="form-control"
                                value={data.status || '1'}
                                onChange={e => handleChange(e.target.value, 'status')}>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        </div>
                    </div>

                    {/* Module access — grouped */}
                    <div style={{
                        fontSize: 12, fontWeight: 500, color: '#595959',
                        textTransform: 'uppercase', letterSpacing: '.05em',
                        marginBottom: 12, paddingBottom: 6,
                        borderBottom: '1px solid #e8e8e8',
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    }}>
                        <span>Module Access</span>
                        <div style={{ display: 'flex', gap: 8 }}>
                            <Button size="small" icon={<CheckSquareOutlined />}
                                onClick={() => {
                                    const all = modules.map(m => m.id);
                                    setData({ ...data, app_modules: all });
                                }}>
                                Select all
                            </Button>
                            <Button size="small" icon={<BorderOutlined />}
                                onClick={() => setData({ ...data, app_modules: [] })}>
                                Clear all
                            </Button>
                        </div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
                        {groupedModules.map(group => {
                            const s          = groupStyle(group.name);
                            const checkState = groupCheckState(group.items);
                            const allChecked = checkState === 'all';
                            const someChecked= checkState === 'some';
                            return (
                                <div key={group.name} style={{
                                    border: `1px solid ${s.border}`,
                                    borderRadius: 8,
                                    overflow: 'hidden',
                                }}>
                                    {/* Group header with select-all toggle */}
                                    <div style={{
                                        background: s.header, color: '#fff',
                                        padding: '8px 12px',
                                        display: 'flex', alignItems: 'center',
                                        justifyContent: 'space-between',
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <Checkbox
                                                checked={allChecked}
                                                indeterminate={someChecked}
                                                onChange={e => toggleGroup(group.items, e.target.checked)}
                                                style={{ '--ant-primary-color': '#fff' }}
                                            />
                                            <span style={{ fontWeight: 600, fontSize: 13 }}>{group.name}</span>
                                        </div>
                                        <span style={{
                                            fontSize: 10, fontWeight: 500,
                                            background: 'rgba(255,255,255,0.2)',
                                            padding: '1px 7px', borderRadius: 8,
                                        }}>
                                            {group.items.filter(m => (data.app_modules || []).includes(m.id)).length}
                                            {' / '}{group.items.length}
                                        </span>
                                    </div>

                                    {/* Module checkboxes */}
                                    <div style={{
                                        background: s.light,
                                        padding: '10px 12px',
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                        gap: '6px 12px',
                                    }}>
                                        {group.items.map(m => (
                                            <Checkbox
                                                key={m.id}
                                                checked={(data.app_modules || []).includes(m.id)}
                                                onChange={e => toggleModule(m.id, e.target.checked)}
                                                style={{ fontSize: 12 }}
                                            >
                                                {m.name}
                                            </Checkbox>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </form>
        </Modal>
    );
});